// HttpServiceImpl.ts
import { IHttpService } from './IHttpService';

class HttpServiceImpl implements IHttpService {
  constructor(private baseUrl: string) {}

  async postData(path: string, data: any): Promise<any> {
    try {
      const fullUrl = `${this.baseUrl}/${path}`;
      const response = await fetch(fullUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error('Error in HTTP POST request:', error);
      throw error;
    }
  }

  async getData(path: string): Promise<any> {
    try {
      const fullUrl = `${this.baseUrl}/${path}`;
      const response = await fetch(fullUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error('Error in HTTP request:', error);
      throw error;
    }
  }
}

export default HttpServiceImpl;
